import { SSCCVisualizerView } from "@/features/sscc-visualizer";
import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";
import { NavigationItems } from "@/shared/types/navigation";

export default function SSCCVisualizer() {
  useDocumentTitle(NavigationItems.SSCC.name);

  return <SSCCVisualizerView />;
}
